const PLAY_CHANNEL_KEY = "sbs-google-play-session";
const PLAY_SOURCE = "google-play";

function canUseSessionStorage() {
  return typeof window !== "undefined" && Boolean(window.sessionStorage);
}

export function initializeAppChannel() {
  if (!canUseSessionStorage()) return;

  const source = new URLSearchParams(window.location.search).get("source");
  if (source === PLAY_SOURCE) {
    window.sessionStorage.setItem(PLAY_CHANNEL_KEY, "true");
  }
}

export function isGooglePlayApp() {
  if (!canUseSessionStorage()) return false;

  return window.sessionStorage.getItem(PLAY_CHANNEL_KEY) === "true";
}
